import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Button, message, Modal, Icon, Select } from "antd";
import { IMG_DEFAULT, cbURL } from "../../common/baseConfig";
import shallowequal from "shallowequal";
import moment from "moment";

const { Option } = Select;
export class PayType extends Component {
  static propTypes = {
    pay: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    showDetail: true,
    visible: false,
    payType: -1,//0支付宝 1微信 2建行 3聚合扫码
    CouponDefaultValue: '0',
    maxDiscountItem: {},
    OrderCouponSelect: []
  }
  componentWillReceiveProps(nextProps){
    if(!shallowequal(this.props.center.maxDiscountItem, nextProps.center.maxDiscountItem)){
      let { maxDiscountItem } = nextProps.center;
      let { OrderNo } = nextProps.pay.fetchGetOrderPayByIdSuccess;
      this.props.actions.fetchUseCoupon({ ID: maxDiscountItem.coupon ? maxDiscountItem.coupon.ID : '0', OrderNo });
    }
  }
  componentDidMount() {
    let path = this.props.history.location.pathname;
    let orderId = path.slice(path.lastIndexOf('/') + 1, path.length);
    let actionApi = this.props.actions;
    //获取订单详情
    actionApi.fetchGetOrderPayById({
      orderId,
    }).then(res => {
      if (res.SuccessResponse) {
        actionApi.fetchGetCanUseCoupon({ orderNo: res.Data.OrderNo });
      }
    });
    //获取支付方式配置
    actionApi.fetchGetPayment();
    //获取token值储存
    actionApi.fetchGetPayToken().then(res => {
      if (res.SuccessResponse) {
        localStorage.setItem('payToken', res.Data.access_token);
      }
    });
  }
  onTypeClick(type) {
    this.setState({
      payType: type,
    })
  }
  queryCompleted() {
    let path = this.props.history.location.pathname;
    let orderId = path.slice(path.lastIndexOf('/') + 1, path.length);
    this.props.actions.fetchQueryOrder({ Id: orderId }).then(res => {
      if (res.SuccessResponse) {
        if (res.Data.PayStatus === 1) {
          this.props.history.push(`/paysuccess/${this.state.payType}/` + orderId);
        } else {
          this.setState({
            visible: false,
          }, () => {
            message.warn("支付未能成功");
          });
        }
      }
    });
  }
  goPay(price) {
    let path = this.props.history.location.pathname;
    let orderId = path.slice(path.lastIndexOf('/') + 1, path.length);
    const { fetchGetOrderPayByIdSuccess } = this.props.pay;
    let { OrderTime, OrderNo } = fetchGetOrderPayByIdSuccess;

    if (this.state.payType === -1) {
      message.warn("请选择一种支付方式");
      return;
    }
    if (moment(new Date()).diff(moment(new Date(OrderTime)), 'minute') > 30) {
      message.warn('该订单已过期，请重新下单');
      this.props.actions.fetchUpdateOrderState({ OrderNo });
      return;
    }
    if (this.state.payType === 0) {
      //支付宝打开支付页面
      //获取token
      this.props.actions.fetchGetAccessToken().then(
        res => {
          if (res.SuccessResponse) {
            let token = res.Data.access_token;
            let params = {};
            params.OutTradeNo = orderId;
            params.Body = "购课支付";
            params.Subject = "购课支付";
            params.TotalAmount = res.Data.Price;
            params.CallerNotifyUrl = `${cbURL}service/datastore/PayGateway/WXFinancePayNotifyZFB`;
            params.CallerReturnUrl = window.location.origin + "/paysuccess/" + this.state.payType + "/" + orderId;
            params.Token = token;
            this.props.actions.fetchAliScanPay(params).then(res => {
              if (res.SuccessResponse) {
                this.setState({
                  visible: true,
                }, () => {
                  const div = document.createElement('div');
                  div.innerHTML = res.Message; // html code
                  document.body.appendChild(div);
                  document.forms.gateway.setAttribute('target', '_blank');
                  document.forms.gateway.submit();
                })
              }
            });
          }
        }
      )
    } else if (this.state.payType === 2) {
      //建设
      this.props.actions.fetchGetAccessToken().then(res => {
        if (res.SuccessResponse) {
          let token = res.Data.access_token;
          let params = {};
          params.OutTradeNo = orderId;
          params.Body = "购课支付";
          params.Subject = "购课支付";
          params.TotalAmount = res.Data.Price;
          params.CallerNotifyUrl = `${cbURL}service/datastore/PayGateway/WXFinancePayNotifyCCB`;
          params.CallerReturnUrl = window.location.origin + "/paysuccess/" + this.state.payType + "/" + orderId;
          params.Token = token;
          this.props.actions.fetchCcbScanPay(params).then(res => {
            if (res.SuccessResponse) {
              this.setState({
                visible: true,
              }, () => {
                const div = document.createElement('div');
                div.innerHTML = res.Message; // html code
                document.body.appendChild(div);
                document.forms.jhform.setAttribute('target', '_blank');
                document.forms.jhform.submit();
              })
            }
          })
        }
      })
    } else {
      //微信和聚合扫码
      this.props.history.push(`/payWithCode/${this.state.payType}/${orderId}`);
    }
  }
  handleChange(value) {
    const { fetchGetOrderPayByIdSuccess } = this.props.pay;
    let { OrderNo } = fetchGetOrderPayByIdSuccess;
    this.props.actions.fetchUseCoupon({ ID: value, OrderNo: OrderNo });
  }
  render() {
    const { fetchGetOrderPayByIdSuccess, fetchGetPaymentSuccess, UseCouponData } = this.props.pay;
    const { OrderCouponSelect, maxDiscountItem } = this.props.center;
    const { showDetail, payType } = this.state;

    return (
      <div className="pay-pay-type">
        <div className="banner">
          <h1>支付中心</h1>
        </div>
        <div className="order-list">
          {
            fetchGetOrderPayByIdSuccess && <div className="order-list-detail">
              <h2>
                <p>订单号:&nbsp;&nbsp;{fetchGetOrderPayByIdSuccess.OrderNo}</p>
                <p onClick={() => this.setState({
                  showDetail: !showDetail,
                })}>{showDetail ? "收起" : "详情"}</p>
              </h2>
              {
                showDetail && <div className="detail-list">
                  {
                    fetchGetOrderPayByIdSuccess.OrderPayDetailList.length > 0 &&
                    fetchGetOrderPayByIdSuccess.OrderPayDetailList.map(item => (
                      <div className="detail-list-item" key={item.ID}>
                        <div className="order-detail">
                          <img src={item.CoverPath || IMG_DEFAULT} alt="" />
                          <h3>
                            <p>{item.Name}</p>
                            <p>授课老师:{item.TeacherDetail_Name || "匿名"}</p>
                          </h3>
                        </div>
                        <div className="pirce">
                          <p>实付金额:</p>
                          <p>¥{item.OrderDetailPrice}</p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              }
            </div>
          }
          {OrderCouponSelect && <div className='coupon_select_box'>
            <p>使用优惠券</p>
            <Select defaultValue={maxDiscountItem.coupon ? maxDiscountItem.coupon.ID : '0'} onChange={this.handleChange.bind(this)} dropdownClassName='coupon_select' style={{ width: 300 }}>
              <Option style={{ width: '100%' }} value="0">不使用优惠券</Option>
              {OrderCouponSelect.map(item => <Option style={{ width: '100%' }} key={item.coupon.ID} value={item.coupon.ID}>使用{item.coupon.FacePrice}元代金券，可抵扣订单金额{item.CouponMoney && (item.CouponMoney).toFixed(2)}元</Option>)}
            </Select>
          </div>}
          <div className="order-list-paytype">
            <h2>
              支付方式
              </h2>
            {
              fetchGetPaymentSuccess && fetchGetPaymentSuccess.length > 0 && <div>
                {
                  fetchGetPaymentSuccess[0].Type === 2 && (
                    <div className="paytype-ways">
                      <div onClick={this.onTypeClick.bind(this, 2)} className={payType === 2 ? "paytype-way-active" : "paytype-way"}>
                        <img src={require("../../images/pay_way2.png")} alt="" />
                      </div>
                      <div onClick={this.onTypeClick.bind(this, 3)} className={payType === 3 ? "paytype-way-active" : "paytype-way"}>
                        <img src={require("../../images/pay_way1.png")} alt="" />
                      </div>
                    </div>
                  )
                }
                {
                  fetchGetPaymentSuccess[0].Type === 1 && (
                    <div className="paytype-ways">
                      {
                        fetchGetPaymentSuccess.map((item, key) => {
                          if (item.PayType === 2) {
                            return (
                              <div key={key} onClick={this.onTypeClick.bind(this, 0)} className={payType === 0 ? "paytype-way-active" : "paytype-way"}>
                                <img src={require("../../images/zhifubao.png")} alt="" />
                              </div>
                            )
                          } else {
                            return (
                              <div key={key} onClick={this.onTypeClick.bind(this, 1)} className={payType === 1 ? "paytype-way-active" : "paytype-way"}>
                                <img src={require("../../images/weixinpay.png")} alt="" />
                              </div>
                            )
                          }
                        })
                      }
                    </div>
                  )
                }
              </div>
            }
          </div>
          {
            fetchGetOrderPayByIdSuccess && <div className="btns">
              <p>请在30分钟内完成支付，如未完成订单将自动关闭，需重新购买</p>
              <p>
                {UseCouponData ? <span className='tit'>优惠券抵扣:</span> : null}
                {UseCouponData ? <span className='total-price'>{UseCouponData.toFixed(2)}</span> : null}
                <span className="tit">应付:</span>
                <span className="total-price">¥{UseCouponData ? (fetchGetOrderPayByIdSuccess.Price - UseCouponData).toFixed(2) : (fetchGetOrderPayByIdSuccess.Price).toFixed(2)}</span>
                <Button type="theme" onClick={this.goPay.bind(this, UseCouponData ? (fetchGetOrderPayByIdSuccess.Price - UseCouponData) : fetchGetOrderPayByIdSuccess.Price)}>立即支付</Button>
              </p>
            </div>
          }
        </div>
        <Modal
          title={null}
          centered
          wrapClassName="payOrderModal"
          maskClosable={false}
          footer={null}
          width={400}
          visible={this.state.visible}
          onCancel={() => this.setState({
            visible: false,
          })}
        >
          <div className="payOrder">
            <p className="p1">
              <Icon type="exclamation-circle" theme="filled" className="icon" />
              <span>请在新打开的页面上完成付款</span>
            </p>
            <p className="p2">付款完成前请不要关闭此窗口;</p>
            <p className="p3">付款完成后请根据您的情况点击下面的按钮</p>
            <div className="btns">
              <Button type="theme2" onClick={this.queryCompleted.bind(this)}>已完成付款</Button>
              <Button type="theme" onClick={() => { this.props.history.push('/help') }}>付款遇到问题</Button>
            </div>
            <u onClick={() => this.setState({ visible: false })}>返回选择其他方式付款</u>
          </div>
        </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pay: state.pay,
    center: state.center
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayType);



// WEBPACK FOOTER //
// ./src/features/pay/PayType.js